import { clearInputField, getQueryStringParameter } from '../../../helpers.js'

$(document).ready(() => {
  const $form = $('form#natural-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'politically_exposed_person') {
    return;
  }

  const $isPoliticallyExposed = $('#isPoliticallyExposed input[type=radio]', $form);
  const $politicallyExposedPersonJob = $('#politicallyExposedPersonJob', $form);

  $isPoliticallyExposed.each((_, inputElement) => {
    if(inputElement.checked && inputElement.value === 'true') {
      $politicallyExposedPersonJob.removeClass('d-none');
    }
  });

  $isPoliticallyExposed.on('click', (inputElement) => {
    if(inputElement.target.value === 'false') {
      $politicallyExposedPersonJob.addClass('d-none');

      var selectedPoliticallyExposedPersonJob = document.querySelector('input[name="users_profile_natural[politically_exposed_person_job]"]:checked');

      if (selectedPoliticallyExposedPersonJob !== null) {
        clearInputField(selectedPoliticallyExposedPersonJob);
      }

      $form.trigger('submit');
    } else {
      $politicallyExposedPersonJob.removeClass('d-none');
    }
  });
})
